import { useMutation, useQueryClient } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useDeleteThread = (matterId: string, subsetId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const deleteThread = async (threadId: string) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.DELETE,
    });

    const response = await fetch(
      `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/thread/${threadId}`,
      fetchConfig,
    );
    if (!response.ok) {
      throw new Error('Creating thread failed');
    }
  };

  return useMutation({
    mutationFn: (threadId: string) => deleteThread(threadId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Threads, { subsetId }] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.PublishedThreads, { subsetId }] });
    },
  });
};
